/**
 * determine if the passed object is plain. Returns false for all class instances.
 */
export function isPlainObject(value) {
  return value && [undefined, Object].includes(value.constructor);
}